import $ from 'jquery';

export default function search() {
  
  function focusSmartphone() {
    $('#keywords').focusin(function() {
      var w = $(window).width();
      if(w < 768) {
        $('.logo').addClass('hide');
      }
    }).focusout(function() {
      $('.logo').removeClass('hide');
    });
  }

  
  $( document ).ready(function() {
    if($('#keywords').length > 0) {
      focusSmartphone();
    }
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/search.js